'use es6';

import { Record } from 'immutable';
import * as Actions from 'FormsUI/actions/formCloning/formCloningActions';
import * as RequestStates from 'FormsCommonComponents/lib/RequestState';
const INITIAL_STATE = new Record({
  requestState: RequestStates.NOT_REQUESTED,
  isTranslating: false
})();
function setRequestState(state, newRequestState) {
  return state.set('requestState', newRequestState);
}
function setTranslatingState(state, isTranslating) {
  return state.set('isTranslating', isTranslating);
}
export function formCloningState(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Actions.REQUEST_FORM_CLONING:
      return setRequestState(state, RequestStates.REQUESTED);
    case Actions.SUCCEED_CLONING_FORM:
      return setRequestState(state, RequestStates.SUCCEEDED);
    case Actions.FAIL_CLONING_FORM:
      return setRequestState(state, RequestStates.FAILED.setMessage(action.reason));
    case Actions.RESET_FORM_CLONING_STATE:
      return setRequestState(state, RequestStates.NOT_REQUESTED);
    case Actions.START_TRANSLATING:
      return setTranslatingState(state, true);
    case Actions.FINISH_TRANSLATING:
      return setTranslatingState(state, false);
    default:
      return state;
  }
}